
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/collection/[category]",
      function () {
        return require("private-next-pages/collection/[category]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/collection/[category]"])
      });
    }
  